module.exports = __webpack_public_path__ + "static/img/logo-txs.0a92f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-txs.png
// module id = Ah/H
// module chunks = 1